import _Promise from "babel-runtime/core-js/promise";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.AGENT_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.AGENT_ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
  });
  _.set(fields, "CITIZENSHIP.FIELD_TYPE", "selector");

  _.set(fields, "CITIZENSHIP.DEFAULT_VALUE", "CHN");
  fields.ID_ADDR.VALID_TYPE = "valAX[16,80]";
  if (vm.$basecfg.isMobileFlag) {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_TITLE = "请仔细核对身份证信息，如有误可点击修改";
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherAgentInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (otherAgentInfo && otherAgentInfo["USER_FNAME"] && otherAgentInfo["ID_TYPE"] && otherAgentInfo["ID_CODE"] && otherAgentInfo["BIRTHDAY"] && otherAgentInfo["ID_EXP_DATE"] && otherAgentInfo["SEX"]) {
    otherAgentInfo["AGENT_USER_FNAME"] = otherAgentInfo["USER_FNAME"];
    otherAgentInfo["AGENT_USER_FNAME_DATA_SOURCE"] = otherAgentInfo["USER_FNAME_DATA_SOURCE"];

    otherAgentInfo["AGENT_ID_TYPE"] = otherAgentInfo["ID_TYPE"];
    otherAgentInfo["AGENT_ID_TYPE_DATA_SOURCE"] = otherAgentInfo["ID_TYPE_DATA_SOURCE"];

    otherAgentInfo["AGENT_ID_CODE"] = otherAgentInfo["ID_CODE"];
    otherAgentInfo["AGENT_ID_CODE_DATA_SOURCE"] = otherAgentInfo["ID_CODE_DATA_SOURCE"];

    otherAgentInfo["AGENT_BIRTHDAY"] = otherAgentInfo["BIRTHDAY"];
    otherAgentInfo["AGENT_BIRTHDAY_DATA_SOURCE"] = otherAgentInfo["BIRTHDAY_DATA_SOURCE"];

    otherAgentInfo["AGENT_ID_EXP_DATE"] = otherAgentInfo["ID_EXP_DATE"];
    otherAgentInfo["AGENT_ID_EXP_DATE_DATA_SOURCE"] = otherAgentInfo["ID_EXP_DATE_DATA_SOURCE"];

    otherAgentInfo["AGENT_SEX"] = otherAgentInfo["SEX"];
    otherAgentInfo["AGENT_SEX_DATA_SOURCE"] = otherAgentInfo["SEX_DATA_SOURCE"];
  }
  if (!_.isEmpty(otherAgentInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherAgentInfo);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var replaceKeys, orgAgentInfo, oldAgentInfo, key, newKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              replaceKeys = "AGENT_";
              orgAgentInfo = bizPublicSaveMethod.getModuleObjctFoyPrefixKey(_this, MODULE_ID, [SAVE_PATH], false, "AGENT_");
              oldAgentInfo = _.get(params, "" + SAVE_PATH);
              ;

              for (key in orgAgentInfo) {
                if (key.includes("AGENT_")) {
                  newKey = key.replace("AGENT_", "");

                  orgAgentInfo[newKey] = orgAgentInfo[key];
                  delete orgAgentInfo[key];
                }
              }
              orgAgentInfo.USER_NAME = orgAgentInfo.USER_FNAME;
              orgAgentInfo.LINKADDR_ORDER = "2";
              orgAgentInfo.LINKTEL_ORDER = "1";

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], orgAgentInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, oldAgentInfo, orgAgentInfo));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      var birthday, age, data, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              birthday = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.AGENT_BIRTHDAY.DEFAULT_VALUE, age = utils.getAge(birthday);

              if (!(age < 18)) {
                _context2.next = 4;
                break;
              }

              alert("代理人未满18岁，不能进行代理开户！");
              return _context2.abrupt("return", false);

            case 4:
              if (!vm.$basecfg.isMobileFlag) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return", true);

            case 6:
              if (!(_this.userType == "1" && (_this.apptStatus == 1 || _this.apptStatus == ""))) {
                _context2.next = 18;
                break;
              }

              data = {
                ID_CODE: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_CODE.DEFAULT_VALUE,
                ID_TYPE: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.ID_TYPE.DEFAULT_VALUE,
                CUST_FNAME: _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE[0].FIELDS.CUST_FNAME.DEFAULT_VALUE,
                USER_TYPE: _this.userType
              };

              _this.$store.commit(_this.$types.UPDATE_LOADING, "正在进行反洗钱查询...");
              _context2.next = 11;
              return _this.$syscfg.K_Request("F0000062", data);

            case 11:
              res = _context2.sent;

              if (!(res.Code == 0)) {
                _context2.next = 17;
                break;
              }

              if (!(res.Data[0] && res.Data[0].AML_LVL == 9)) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return", new _Promise(function (resolve, reject) {
                _this.alert("系统检测到您的账户存在风险，请您临柜开户！");
                resolve(false);
              }).then(function (res) {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                return res;
              }).finally(function () {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
              }));

            case 15:
              _context2.next = 18;
              break;

            case 17:
              return _context2.abrupt("return", new _Promise(function (resolve, reject) {
                _this.alert("反洗钱查询失败, 请稍后重试!");
                resolve(false);
              }).then(function (res) {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                return res;
              }).finally(function () {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
              }));

            case 18:
              return _context2.abrupt("return", true);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {},
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},

  "CHECK_AGENT_ID_TYPE": function CHECK_AGENT_ID_TYPE(_this, field, fieldData, moduleObj, index, isAuto) {
    if (field.DEFAULT_VALUE == "") {
      return;
    }
    _this.$blMethod.checkIdTypeRelateFields(_this, fieldData, ["AGENT_ID_TYPE", "AGENT_ID_CODE", "AGENT_ID_EXP_DATE"]);

    if (!_this.oppBusiData.isLoadData) {
      fieldData.AGENT_ID_CODE.DEFAULT_VALUE = "";
    }
    if (["00", "0J"].includes(field.DEFAULT_VALUE)) {
      fieldData.AGENT_SEX.FIELD_CONTROL = "2";
      fieldData.AGENT_BIRTHDAY.FIELD_CONTROL = "2";
    } else {
      fieldData.AGENT_SEX.FIELD_CONTROL = "0";
      fieldData.AGENT_BIRTHDAY.FIELD_CONTROL = "0";
    }
  },
  "CHECK_AGENT_ID_CODE": function CHECK_AGENT_ID_CODE(_this, field, fieldData, moduleObj, index, isAuto) {
    if (field.DEFAULT_VALUE == "") {
      return;
    }
    field.DEFAULT_VALUE && _this.$blMethod.isDisabledLongTime(_this, fieldData.AGENT_ID_TYPE.DEFAULT_VALUE, fieldData.AGENT_ID_CODE.DEFAULT_VALUE, fieldData.AGENT_ID_EXP_DATE);
    fieldData.AGENT_SEX.DEFAULT_VALUE = utils.getSex(field.DEFAULT_VALUE);
    fieldData.AGENT_BIRTHDAY.DEFAULT_VALUE = utils.getBirthday(field.DEFAULT_VALUE);
  }

};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOcrInfo/bizOrgAgentBasicInfoNode.js
// module id = 154
// module chunks = 2